export const getHistory = (state: any) => state.history;
